var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.97,
    height: 15.973,
    viewBox: "0 0 15.97 15.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign-out",
    opacity: 0.301
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8439",
    "data-name": "Path 8439",
    d: "M16.862,7.777,14.28,5.2a.665.665,0,1,0-.941.941l2.582,2.582a1.369,1.369,0,0,1,.2.26c-.01,0-.018-.005-.028-.005h0L5.655,8.993a.666.666,0,1,0,0,1.331h0L16.089,10.3c.019,0,.034-.009.052-.011a1.331,1.331,0,0,1-.222.307l-2.582,2.582a.665.665,0,1,0,.941.941l2.582-2.582a2.662,2.662,0,0,0,0-3.764Z",
    transform: "translate(-1.669 -1.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8440",
    "data-name": "Path 8440",
    d: "M4.659,14.642H3.328a2,2,0,0,1-2-2V3.328a2,2,0,0,1,2-2H4.659A.666.666,0,1,0,4.659,0H3.328A3.332,3.332,0,0,0,0,3.328v9.317a3.332,3.332,0,0,0,3.328,3.328H4.659a.666.666,0,1,0,0-1.331Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.25cb1f5202fc952d8f16a8eedfc6af79.svg";
export { ForwardRef as ReactComponent };